import EF from 'ef/ef';
import View from 'views/base/view';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import SurveyService from 'services/data-handler-services/survey-service';
import ProgressService from 'services/course-handler-services/progress-service';
import SurveyTemplate from './templates/survey';

const SurveyView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: SurveyTemplate,
  className: 'card',
  listen: {
    addedToDOM: 'loaded',
  },
  loaded: function () {
    const self = this;
    this.delegate('click', '.btn-survey.bg-color-error-base', function (e) {
      const button = e.currentTarget;
      const surveySlug = button.attributes['data-survey'].value;
      ProgressService.removeLocalActivityProgress(surveySlug).done(() => self.render());
    });
    this.delegate('click', '.btn-survey.bg-color-success-base', function (e) {
      const button = e.currentTarget;
      ProgressService.saveLocalActivityProgress({
        attempt: 1,
        enrollment_id: EF.enrollment.get('id'),
        grade: null,
        passed: true,
        slug: button.attributes['data-survey'].value,
      }).done(() => self.render());
    });
  },
  getTemplateData: function () {
    const model = {
      surveys: [],
    };

    if (CourseSettingsService.get('surveys')) {
      CourseSettingsService.get('surveys').forEach(survey => {
        model.surveys.push({
          slug: survey,
          progress: SurveyService.getActivityProgressForSlug(survey),
        });
      });
    }
    return model;
  },
});

export default SurveyView;
